/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import Dummy from '../../../assets/images/dr_dummy.jpg'
import { ReactComponent as ArrowDown } from '../../../assets/icons/arrow_down.svg'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../Redux/auth/authSlice'

function UserSettings() {
  const [activeMenu, setActiveMenu] = useState(false)
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const { profile, user } = auth.user || {}

  const usedName = 'Dr, ' + (profile?.displayName || user?.displayName || 'No name')
  const usedImage = user?.photoUrl || profile?.photoUrl || Dummy

  const buttonRef = useRef(null) // Create a ref for the button

  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setActiveMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [activeMenu])

  const signout = () => {
    dispatch(logout())
  }

  return (
    <div ref={buttonRef} className={`${styles.user_wrapper} ${activeMenu ? styles.active : ''}`}>
      <button className={styles.img_button} onClick={() => setActiveMenu((prev) => !prev)}>
        <img className={styles.dr_img} src={usedImage} alt='dr_img' />
        <ArrowDown />
      </button>
      <div className={styles.settings_menu}>
        <span className={styles.user_name}>{usedName}</span>
        <button className={styles.signout} onClick={signout}>
          Sign Out
        </button>
      </div>
    </div>
  )
}
export default UserSettings
